import React from "react";
import { Link } from "react-router-dom";
import { routes } from "../../data/business";
import { resourceTopics } from "../../data/home";
import { images } from "../../data/images";
import { Reveal } from "../ui/Reveal";
import { SectionHeading } from "../ui/SectionHeading";
import { buttonStyles } from "../ui/buttonStyles";
export function ResourcesTeaser() {
  return <section aria-labelledby="res-title" className="grain section-y gutter bg-navy-800 text-white" data-id="element-268" data-mp="14fh55s43gd57">
      <div className="grid items-center gap-[clamp(3rem,6vw,8rem)] lg:grid-cols-[1.1fr_0.9fr]" data-id="element-269" data-mp="19eld6ffa84ty">
        <div data-id="element-270" data-mp="1edojs4awuj41">
          <SectionHeading id="res-title" tone="dark" eyebrow="Nevada court & inmate resources" title={<>
                Can't find them? <em className="text-gold-soft" data-id="element-272" data-mp="3g5b2liknf7pf">Start here.</em>
              </>} intro="If you're having trouble locating someone who's been arrested, or need links to Nevada courts, justice calendars, records, or victim's resources, our resources page gathers them in one place — including how to visit, send money, and accept calls." data-id="element-271" data-mp="1ed528op69wqj" />
          <ul className="mt-8 flex flex-wrap gap-2" data-id="element-273" data-mp="1cmhkqoiycndc">
            {resourceTopics.map(t => <li key={t} className="rounded-full border border-gold/30 px-4 py-2 text-sm text-white/80" data-id="element-274" data-mp="17nddi3fl8zpn">
                {t}
              </li>)}
          </ul>
          <Link to={routes.resources} className={`${buttonStyles.gold} mt-10`} data-id="element-275" data-mp="20cu3yvjne6j8">
            Browse Resources →
          </Link>
        </div>
        <Reveal data-id="element-276" data-mp="1vd7riobn8ubh">
          <img src={images.hands} alt="Two hands clasped in reassurance across a table" loading="lazy" className="aspect-[4/3] w-full rounded-3xl border border-gold/25 object-cover shadow-glass" data-id="element-277" data-mp="1qfpfgp2bxyz9" />
        </Reveal>
      </div>
    </section>;
}